/*import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { db } from './firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import Product from './Product';
import './SearchResults.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SearchResults() {
  const queryParam = useQuery();
  const searchTerm = queryParam.get('q') || '';
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!searchTerm) return;

    const fetchResults = async () => {
      const prodottiRef = collection(db, 'prodotti');
      const q = query(
        prodottiRef,
        where('title', '>=', searchTerm),
        where('title', '<=', searchTerm + '\uf8ff')
      );

      const snapshot = await getDocs(q);
      const products = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setResults(products);
    };

    fetchResults();
  }, [searchTerm]);

  return (
    <div className='search_results'>
      <h2>Risultati per: "{searchTerm}"</h2>
      <div className='search_row'>
        {results.map((product) => (
          <div
            key={product.id}
            onClick={() => navigate(`/product/${product.id}`)}
            style={{ cursor: 'pointer' }}
          >
            <Product {...product} />
          </div>
        ))}
        {results.length === 0 && <p>Nessun prodotto trovato</p>}
      </div>
    </div>
  );
}

export default SearchResults;*/


import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { db } from './firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import Product from './Product';
import './SearchResults.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SearchResults() {
  const queryParam = useQuery();
  const searchTerm = queryParam.get('q') || '';
  const selectedCategory = queryParam.get('category') || '';
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchResults = async () => {
      setLoading(true);
      const prodottiRef = collection(db, 'prodotti');
      let q;

      if (selectedCategory) {
        // Interroga Firestore usando il campo 'tipologia' che hai inserito
        q = query(prodottiRef, where('tipologia', '==', selectedCategory));
      } else if (searchTerm) {
        // Ricerca per nome (case-insensitive)
        const cleanSearch = searchTerm.trim().toLowerCase();
        q = query(
          prodottiRef,
          where('title_lowercase', '>=', cleanSearch),
          where('title_lowercase', '<=', cleanSearch + '\uf8ff')
        );
      } else {
        q = prodottiRef;
      }

      try {
        const snapshot = await getDocs(q);
        const products = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setResults(products);
      } catch (err) {
        console.error("Errore recupero prodotti:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [searchTerm, selectedCategory]);

  return (
    <div className='search_results'>
      <h2>
        {selectedCategory 
          ? `Categoria: ${selectedCategory}`
          : searchTerm 
            ? `Risultati per: "${searchTerm}"`
            : "Tutti i prodotti"}
      </h2>

      {loading ? (
        <p>Caricamento prodotti...</p>
      ) : (
        <div className='search_row'>
          {results.map((product) => (
            <div
              key={product.id}
              onClick={() => navigate(`/product/${product.id}`)}
              style={{ cursor: 'pointer' }}
            >
              <Product {...product} />
            </div>
          ))}
          {results.length === 0 && <p>Nessun prodotto trovato in questa categoria</p>}
        </div>
      )}
    </div>
  );
}

export default SearchResults;
